export default {
    FIRST_STEP_1_TOOLTIPS:`<a rel='noopener noreferrer' target='_blank' href="https://academy.clara.co/article/4prCrt3uprKNf5bhkYAMyI" > <b>Founders</b> (or co-founders) </a> are the people who kicked off this whole adventure, through the initial development and creation of the startup.`,
    FIRST_STEP_2_TOOLTIPS:'Add founders in any order.',
    SECOND_STEP_IS_ANOTHER_TOOLTIPS:'Team work makes the startup dream work.',
    SECOND_STEP_IS_NOT_ANOTHER_TOOLTIPS:'With great power comes great responsibility.'
}
